import React from 'react';

import LoginContainer from './LoginContainer';
import LoginPage from './LoginPage';

const Login: React.FC = () => (
    <LoginContainer.Provider>
        <LoginPage />
    </LoginContainer.Provider>
);

export default Login;
